import { parseEndOfDayFromQueryParam } from '@helpers/parseEndOfDayFromQueryParam';
import { parseStartOfDayFromQueryParam } from '@helpers/parseStartOfDayFromQueryParam';
import { serializeDateToQueryParam } from '@helpers/serializeDateToQueryParam';
import type { TSearchParamsPatch } from 'app/helpers/patchSearchParams';
import type { TJobsFilter } from 'app/types/TJobsFilter';
import { useMemo } from 'react';

type TOptions = {
  searchParams: URLSearchParams;
  updateParams: (patch: TSearchParamsPatch, options?: { resetPage?: boolean }) => void;
};

type TApplyOptions = {
  onUnchanged?: () => void;
};

export type TJobsFilterUpdate = TJobsFilter | ((current: TJobsFilter) => TJobsFilter);

export const useJobsFilterQueryParams = ({ searchParams, updateParams }: TOptions) => {
  const jobsFilter = useMemo<TJobsFilter>(
    () => ({
      from: parseStartOfDayFromQueryParam(searchParams.get('from')),
      to: parseEndOfDayFromQueryParam(searchParams.get('to')),
    }),
    [searchParams],
  );

  const applyJobsFilter = (update: TJobsFilterUpdate, { onUnchanged }: TApplyOptions = {}) => {
    const next = typeof update === 'function' ? update(jobsFilter) : update;
    const from = serializeDateToQueryParam(next.from);
    const to = serializeDateToQueryParam(next.to);
    if (from === serializeDateToQueryParam(jobsFilter.from) && to === serializeDateToQueryParam(jobsFilter.to)) {
      onUnchanged?.();
      return;
    }
    updateParams({ from: from || null, to: to || null }, { resetPage: true });
  };

  return { jobsFilter, applyJobsFilter };
};
